// ── InterestStatementModal ──
import { useState } from "react";
import { Btn, FInput, Field, Modal } from "../../../shared/ui";
import { useApp } from "../../../shared/appContext";

export const InterestStatementModal = ({ accountid, companyname }) => {
    const { api, tab, closeModal, error, authState } = useApp();
    const today = new Date();
    const firstOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastOfPriorMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    const firstOfPriorMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  
    const fmt8 = d => d.toISOString().slice(0, 10);
  
    const [startdate, setStartdate] = useState(fmt8(firstOfPriorMonth));
    const [enddate, setEnddate]     = useState(fmt8(lastOfPriorMonth));
    const [generating, setGenerating] = useState(false);
    const [genError, setGenError]   = useState(null);
  
  const handleGenerate = async () => {
    const token = authState?.token || null;
    const onClose = closeModal;

  setGenerating(true); setGenError(null);
  try {
    const url = `/api/generateInterestStatement?accountid=${accountid}&startdate=${startdate}&enddate=${enddate}`;
    const headers = token ? { Authorization: 'Bearer ' + token } : {};
    const res = await fetch(url, { headers });

    // Read body ONCE as blob — works for both success (xlsx) and error (json)
    const blob = await res.blob();

if (!res.ok) {
  const errText = await blob.text();
  let errMsg = 'Failed to generate statement';
  try { errMsg = JSON.parse(errText).error || errMsg; }
  catch { errMsg = errText || errMsg; }
  throw new Error(errMsg || `HTTP ${res.status}: ${res.statusText}`);
}

    // Success — trigger download
    const name = `Interest_Statement_${companyname.replace(/[^a-zA-Z0-9]/g,'_')}_${startdate}_${enddate}.xlsx`;
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = name;
    a.click();
    URL.revokeObjectURL(a.href); // clean up
    onClose();
  } catch (e) {
    setGenError(e.message);
    setGenerating(false);
  }
};
  
    return (
      <Modal title="Generate Interest Statement" onClose={closeModal}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 16 }}>
            Generates one Excel tab per active loan for <strong>{companyname}</strong>.
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <Field label="Beginning Date">
              <FInput type="date" value={startdate} onChange={setStartdate} />
            </Field>
            <Field label="Ending Date">
              <FInput type="date" value={enddate} onChange={setEnddate} />
            </Field>
          </div>
          <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 8 }}>
            Rate used will be the index rate loaded for the month prior to the beginning date.
          </div>
        </div>
        {genError && (
          <div style={{ background: '#FAECE7', border: '0.5px solid #E8B4A8', borderRadius: 6, padding: '10px 14px', fontSize: 13, color: '#993C1D', marginBottom: 16 }}>
            ⚠️ {genError}
          </div>
        )}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <Btn onClick={closeModal}>Cancel</Btn>
          <Btn
            variant="primary"
            disabled={generating || !startdate || !enddate}
            onClick={handleGenerate}
          >
            {generating ? 'Generating...' : '⬇ Download Statement'}
          </Btn>
        </div>
      </Modal>
    );
  };
